/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import InViewObserver from 'components/InViewObserver/InViewObserver';
import LoaderSpinner from '../LoaderSpinner/LoaderSpinner';

const isFrameInContent = value => {
  const pattern = /<iframe/;
  return pattern.test(value);
};

class CData extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      elemInView: false,
      placeHolderClass: this.getPlcHolderClass(props),
    };
  }
  componentWillMount() {
    if (!this.props.applyLazyLoadLogic) {
      if (
        typeof document !== 'undefined' &&
        this.props.type &&
        this.props.type.toLowerCase() === 'twitter' &&
        typeof twttr === 'undefined'
      ) {
        const s = document.createElement('script');
        s.setAttribute('src', `https://platform.twitter.com/widgets.js`);
        s.onload = () => {
          this.renderTweet();
        };
        document.body.appendChild(s);
      } else if (
        typeof document !== 'undefined' &&
        this.props.type &&
        this.props.type.toLowerCase() === 'instagram' &&
        typeof instgrm === 'undefined'
      ) {
        const s = document.createElement('script');
        s.setAttribute('src', `https://platform.instagram.com/en_US/embeds.js`);
        s.onload = () => {
          this.renderInstagramEmbeds();
          // this.setState({ isLoaded: true });
        };
        document.body.appendChild(s);
      }
    }
  }

  componentDidMount() {
    if (
      !this.props.applyLazyLoadLogic &&
      this.props.type &&
      this.props.type.toLowerCase() === 'twitter'
    ) {
      this.renderTweet();
    } else if (
      this.props.type &&
      this.props.type.toLowerCase() === 'instagram'
    ) {
      this.renderInstagramEmbeds();
    }
  }

  getPlcHolderClass = props => {
    if (props?.type === 'instagram') {
      return 'plcInsta';
    }
    if (props?.type === 'twitter') {
      return 'plcTwttr';
    }
    return '';
  };

  renderTweet = () => {
    if (typeof twttr !== 'undefined') {
      setTimeout(() => {
        twttr.widgets.load();
      }, 0);
    }
  };

  renderInstagramEmbeds = () => {
    if (typeof instgrm !== 'undefined') {
      setTimeout(() => {
        window.instgrm.Embeds.process();
      }, 0);
    }
  };

  render() {
    const { applyLazyLoadLogic, disableUnscape, type, isMweb } = this.props;
    let { value } = this.props;
    if (type === 'twitter') {
      value = value.replace('"/></blockquote>', '"></a></blockquote>');
    }
    const isLoaderEnable = type === 'instagram' || type === 'twitter';
    const viewGap = isMweb ? '400px 0px 400px 0px' : '300px 0px 300px 0px';
    if (
      applyLazyLoadLogic &&
      (isFrameInContent(value) ||
        type.toLowerCase() === 'instagram' ||
        type.toLowerCase() === 'twitter')
    ) {
      return (
        <InViewObserver
          placeHolderClass={
            isLoaderEnable ? `${this.state.placeHolderClass} socialembed` : ''
          }
          viewMargin={viewGap}
          inViewCallback={() => {
            this.setState({ elemInView: true }, () => {
              if (type === 'instagram') {
                this.renderInstagramEmbeds();
              } else if (type === 'twitter') {
                this.renderTweet();
              }
            });
          }}
        >
          <>
            {isLoaderEnable && (
              <div>
                <LoaderSpinner overwriteLoader="socialembed-loader" />
              </div>
            )}
            {this.state.elemInView && (
              <div
                //style={{ display: 'inline' }}
                className={`cdatainfo ${
                  this.props.className ? this.props.className : ' '
                } ${this.props.nic ? '' : 'id-r-component'} ${
                  this.props.isJumpLinkParent ? 'cdata-unset-overflow' : ''
                }`}
                data-pos={this.props.pos}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: disableUnscape ? value : unescape(value),
                }}
              />
            )}
          </>
        </InViewObserver>
      );
    }

    return (
      <div
        //style={{ display: 'inline' }}
        className={`cdatainfo ${
          this.props.className ? this.props.className : ' '
        } ${this.props.nic ? '' : 'id-r-component'} ${
          this.props.isJumpLinkParent ? 'cdata-unset-overflow' : ''
        }`}
        data-pos={this.props.pos}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: this.props.disableUnscape ? value : unescape(value),
        }}
      />
    );
  }
}

CData.propTypes = {
  value: PropTypes.string.isRequired,
  // type: PropTypes.string,
  pos: PropTypes.string,
  className: PropTypes.string,
  styleObj: PropTypes.shape({}).isRequired,
  nic: PropTypes.bool,
  disableUnscape: PropTypes.bool,
  isJumpLinkParent: PropTypes.bool,
  applyLazyLoadLogic: PropTypes.bool,
  type: PropTypes.string,
  isMweb: PropTypes.bool,
};

CData.defaultProps = {
  // type: '',
  pos: '0',
  nic: false,
  disableUnscape: false,
  className: '',
  isJumpLinkParent: false,
  applyLazyLoadLogic: false,
  type: '',
  isMweb: false,
};

export default CData;
